import React from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import AdServerAccessForm from './AdServerAccessForm'

import { getAppDomainName } from '../../../features/helpers/getAppDomainName'

import useCommonStyles from '../../../styles/common/listPage'

function OnSiteAdServer() {
  const commonClasses = useCommonStyles()

  const { t } = useTranslation()
  const appName = getAppDomainName()

  return (
    <>
      <div className={classnames(commonClasses.heading)}>
        <h3 className={commonClasses.title}>{t('Onsite Ad Server')}</h3>
        <p>
          {t(
            `If you offer onsite digital inventory to your partners, you can track it in ${appName} by linking your ad server below:`
          )}
        </p>
      </div>
      <AdServerAccessForm />
    </>
  )
}

export default OnSiteAdServer
